import React, { ReactNode } from "react"
import { LoadingButtonBody } from "./LoadingButtonBody"
import { Button } from "./Button"
export function FilledButton({ label, disabled, onClick, className, loading = false, type = 'button' }: { label: string | ReactNode, disabled?: boolean, className?: string, onClick?: () => void, loading?: boolean, type?: 'button' | 'submit' }): JSX.Element {
  return <Button onClick={onClick} className={`h-10 px-8 w-fit bg-cents-purple text-cents-white font-medium rounded-xl transition-all duration-300 ease-out flex items-center justify-center`
    .concat(className ? ` ${className}` : "")} disabled={disabled || loading} loading={loading} type={type}>
    <LoadingButtonBody label={label} loading={loading} />
  </Button>
}